import { api } from '@api/client'

let response
let result
let error

export const authService = {
  async login (email, password) {
    response = await api.post('/users/login', { email, password })
    result = response.data.result
    error = response.data.error
    return { result, error }
  },

  async logout () {
    await api.post('/auth/logout')
  },

  async refreshToken () {
    response = await api.post('/auth/refresh')
    result = response.data.result
    error = response.data.error
    return { result, error }
  }
}
